import useStore from '@/stores/useStore';
import { FormActionType } from '@/types/shared';

export const useModalButtonActions = () => {
  const { setDemoModalOpen, setTrialModalOpen } = useStore();

  const modalActionHandler = (action?: FormActionType) => {
    if (!action) return;

    switch (action) {
      case 'trial':
        setTrialModalOpen(true);
        break;
      case 'demo':
        setDemoModalOpen(true);
        break;

      default:
        break;
    }
  };

  return { modalActionHandler };
};
